import React, { memo, useMemo } from "react"
import { css } from "@emotion/react"
import { withCssUnit } from "@ncs/ts-utils"
import { ncsBlue, ncsWhite } from "../images/logos"

export type LogoNames = "ncs" | "ncsWhite"

export interface LogoProps {
	company?: LogoNames
	maxWidth?: string | number
	width?: string | number
	height?: string | number
}

export const Logo: React.FC<LogoProps> = memo(({ company = "ncs", maxWidth, width, height }) => {
	const logoSrc = useMemo(() => {
		switch (company) {
			case "ncsWhite":
				return ncsWhite
			case "ncs":
			default:
				return ncsBlue
		}
	}, [company])

	const style = useMemo(() => {
		return css`
			display: inline-block;
			max-width: ${maxWidth != null ? withCssUnit(maxWidth) : "none"};
			width: ${withCssUnit(width) ?? "100%"};
			height: ${withCssUnit(height)};

			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		`
	}, [width, maxWidth, height])

	return (
		<div css={style}>
			<img
				width={width ?? "auto"}
				height={height ?? "auto"}
				src={logoSrc}
				alt={`${company} logo`}
			/>
		</div>
	)
})
